var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-enviroment-18x18",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,15 L10,16.3859863 L13.2033691,16.3859863 C13.6175827,16.3859863 13.9533691,16.7217728 13.9533691,17.1359863 C13.9533691,17.5501999 13.6175827,17.8859863 13.2033691,17.8859863 L4.70336914,17.8859863 C4.28915558,17.8859863 3.95336914,17.5501999 3.95336914,17.1359863 C3.95336914,16.7217728 4.28915558,16.3859863 4.70336914,16.3859863 L8,16.3859863 L8,15 L2,15 C0.8954305,15 0,14.1045695 0,13 L0,2 C0,0.8954305 0.8954305,0 2,0 L16,0 C17.1045695,0 18,0.8954305 18,2 L18,13 C18,14.1045695 17.1045695,15 16,15 L10,15 Z M16.5,11 L16.5,2 C16.5,1.72385763 16.2761424,1.5 16,1.5 L2,1.5 C1.72385763,1.5 1.5,1.72385763 1.5,2 L1.5,11 L16.5,11 Z M1.5,13 C1.5,13.2761424 1.72385763,13.5 2,13.5 L16,13.5 C16.2761424,13.5 16.5,13.2761424 16.5,13 L16.5,12.5 L1.5,12.5 L1.5,13 Z",
    id: "Combined-Shape",
    fill: "#9CAAB4",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatform);
export default __webpack_public_path__ + "static/media/platform.b32c670ce98e7b88b091d5c8e2f584d3.svg";
export { ForwardRef as ReactComponent };